import { ActionTypes } from "../constants/action-types"

const initialState = {
    tutorialCategories:[]

}

export const FetchTutorialCategories = (state=initialState, {type, payload})=>{
switch (type){
    case ActionTypes.FETCH_TUTORIAL_CATEGORY: 
    return {...state, tutorialCategories: payload}
    default: return state
}

}